import React from "react";

function ContactPage() {
    return (
        <div className="container">
            <div className="hero-block">
                <div className="hero-heading-wrap">
                    <div className="hero-icon">
                        <div className="icon-svg w-embed">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                 className="w-6 h-6">
                                <path
                                    d="M19.5 22.5a3 3 0 003-3v-8.174l-6.879 4.022 3.485 1.876a.75.75 0 01-.712 1.321l-5.683-3.06a1.5 1.5 0 00-1.422 0l-5.683 3.06a.75.75 0 01-.712-1.32l3.485-1.877L1.5 11.326V19.5a3 3 0 003 3h15z"/>
                                <path
                                    d="M1.5 9.589v-.745a3 3 0 011.578-2.641l7.5-4.039a3 3 0 012.844 0l7.5 4.039A3 3 0 0122.5 8.844v.745l-8.426 4.926-.652-.35a3 3 0 00-2.844 0l-.652.35L1.5 9.59z"/>
                            </svg>
                        </div>
                    </div>
                    <h1 className="hero-heading">Contact</h1>
                </div>
                <div className="text-lead">
                    Feel free to reach out to me
                </div>
            </div>
            <div className="block-divider"></div>
            <div className="section-block">
                <div className="content-title-wrap">
                    <div className="content-title-dot"></div>
                    <h2 className="content-title">Stay connected</h2>
                </div>
                <div className="w-layout-grid _4x-column">
                    <div id="w-node-c98478fb-b849-c8b6-5d74-2ac4447cab12-a30fcb40" data-w-id="c98478fb-b849-c8b6-5d74-2ac4447cab12" className="card">
                        <div className="shine-wrap">
                            <div className="shine"></div>
                        </div>
                        <div className="card-content-vertical">
                            <img
                                src="https://assets.website-files.com/6411781e218c5f345b4cd7bd/6414287150fd80bf1bd77518_Bildschirmfoto%202023-03-17%20um%2009.43.01.png"
                                loading="lazy" style={{opacity: 0.5}}
                                sizes="(max-width: 479px) 93vw, (max-width: 767px) 96vw, (max-width: 991px) 93vw, 64vw"
                                srcSet="https://assets.website-files.com/6411781e218c5f345b4cd7bd/6414287150fd80bf1bd77518_Bildschirmfoto%202023-03-17%20um%2009.43.01-p-500.png 500w, https://assets.website-files.com/6411781e218c5f345b4cd7bd/6414287150fd80bf1bd77518_Bildschirmfoto%202023-03-17%20um%2009.43.01-p-800.png 800w, https://assets.website-files.com/6411781e218c5f345b4cd7bd/6414287150fd80bf1bd77518_Bildschirmfoto%202023-03-17%20um%2009.43.01.png 2014w"
                                alt="" className="map-image"/>
                            <div  className="map-outline"></div>
                            <div className="map-info">
                                <div className="map-info-item">
                                    <div className="w-layout-grid map-links-grid">
                                        <div id="w-node-_093978ed-d865-aab7-a8b5-c090d453e27a-a30fcb40">
                                            <div className="map-info-heading">Mufaro Gomera</div>
                                            <div>1 Jan Smuts Ave, Braamfontein, Johannesburg, 2000, South Africa</div>
                                        </div>
                                        <div id="w-node-_2c986120-4a92-938d-1d24-6b52be79ada7-a30fcb40">
                                            <a href="#" className="button-small is-map w-button">Go</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="map-info-item is-last">
                                    <div className="w-layout-grid map-links-grid">
                                        <div id="w-node-_514b6dfd-cb5e-8d8e-9d05-c59369cbd762-a30fcb40"
                                             className="map-links">
                                            <a href="tel:+49123456789" className="text-link">+27 63 149 0446</a>
                                            <a href="mailto:hello@template.com"
                                               className="text-link">mufarogomera@gmail.com</a>
                                        </div>
                                        <div id="w-node-_514b6dfd-cb5e-8d8e-9d05-c59369cbd767-a30fcb40"
                                             className="map-buttons">
                                            <a href="#" className="button-small is-circle w-button">☎️</a>
                                            <a href="#" className="button-small is-circle w-button">📫</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a href="#" className="card w-inline-block">
                        <div className="shine-wrap">
                            <div className="shine"></div>
                        </div>
                        <div className="card-content-vertical">
                            <div className="app-list-wrap">
                                <div>
                                    <div className="app-list">
                                        <div className="app-wrap">
                                            <div className="app-icon w-embed">
                                                <svg viewBox="0 0 40 40" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="40" height="40" rx="0" fill="#006699"></rect>
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M14.7344 29V15.5053H10.249V29H14.7344ZM12.4917 13.6629C14.0558 13.6629 15.0294 12.6266 15.0294 11.3316C15.0002 10.0075 14.0558 9 12.5214 9C10.9871 9 9.98389 10.0075 9.98389 11.3316C9.98389 12.6266 10.9572 13.6629 12.4625 13.6629H12.4916H12.4917Z"
                                                          fill="white"></path>
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M17.2163 29H21.7016V21.464C21.7016 21.0607 21.7308 20.6578 21.8492 20.3695C22.1735 19.5636 22.9115 18.7291 24.1506 18.7291C25.7736 18.7291 26.4229 19.9666 26.4229 21.7807V29H30.9078V21.2624C30.9078 17.1174 28.695 15.1887 25.744 15.1887C23.3243 15.1887 22.262 16.5412 21.6718 17.4624H21.7017V15.5053H17.2164C17.2753 16.7716 17.2164 29 17.2164 29H17.2163Z"
                                                          fill="white"></path>
                                                </svg>
                                            </div>
                                            <div className="app-outline"></div>
                                        </div>
                                        <div>LinkedIn</div>
                                    </div>
                                </div>
                                <div id="w-node-_586e4c93-2eba-d515-1276-04e6e65a44a7-a30fcb40">
                                    <div className="card-cta">
                                        <div className="icon-svg w-embed">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a href="#" className="card w-inline-block">
                        <div className="shine-wrap">
                            <div className="shine"></div>
                        </div>
                        <div className="card-content-vertical">
                            <div className="app-list-wrap">
                                <div>
                                    <div className="app-list">
                                        <div className="app-wrap">
                                            <div className="app-icon w-embed">
                                                <svg viewBox="0 0 40 40" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="40" height="40" rx="0" fill="white"></rect>
                                                    <path
                                                        d="M17.9792 12.2719C17.4566 12.1263 16.9114 12.4199 16.7615 12.9277C16.6117 13.4356 16.9139 13.9653 17.4365 14.1109L25.3857 16.3257C25.9084 16.4714 26.4536 16.1777 26.6034 15.6699C26.7533 15.162 26.4511 14.6323 25.9285 14.4867L17.9792 12.2719Z"
                                                        fill="#222222"></path>
                                                    <path
                                                        d="M15.7848 16.238C15.9346 15.7302 16.4798 15.4365 17.0025 15.5822L24.9517 17.797C25.4743 17.9426 25.7765 18.4723 25.6267 18.9802C25.4768 19.488 24.9316 19.7816 24.409 19.636L16.4597 17.4212C15.9371 17.2756 15.6349 16.7458 15.7848 16.238Z"
                                                        fill="#222222"></path>
                                                    <path
                                                        d="M16.0253 18.8924C15.5026 18.7468 14.9575 19.0404 14.8076 19.5483C14.6577 20.0561 14.9599 20.5859 15.4826 20.7315L20.4035 22.1025C20.9262 22.2482 21.4713 21.9545 21.6212 21.4467C21.7711 20.9389 21.4689 20.4091 20.9462 20.2635L16.0253 18.8924Z"
                                                        fill="#222222"></path>
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                          d="M13.4646 10.2181C13.9441 8.59302 15.6887 7.65339 17.3612 8.11937L28.7172 11.2834C30.3897 11.7494 31.3567 13.4445 30.8772 15.0696L26.5354 29.7819C26.0559 31.407 24.3113 32.3466 22.6388 31.8806L11.2828 28.7166C9.61031 28.2506 8.64328 26.5555 9.12285 24.9304L13.4646 10.2181ZM16.8185 9.95841L28.1745 13.1224C28.8017 13.2972 29.1643 13.9328 28.9845 14.5423L24.6428 29.2546C24.4629 29.864 23.8087 30.2163 23.1815 30.0416L11.8255 26.8776C11.1983 26.7028 10.8357 26.0672 11.0155 25.4578L15.3572 10.7454C15.5371 10.136 16.1913 9.78367 16.8185 9.95841Z"
                                                          fill="#222222"></path>
                                                </svg>
                                            </div>
                                            <div className="app-outline"></div>
                                        </div>
                                        <div>Read CV</div>
                                    </div>
                                </div>
                                <div id="w-node-_85d6ab6b-30bd-fc24-366d-845f7e32044a-a30fcb40">
                                    <div className="card-cta">
                                        <div className="icon-svg w-embed">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                 viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a id="w-node-dbc4756d-8d63-cab0-fa6b-e43296fb0381-a30fcb40" href="#"
                       className="card w-inline-block">
                        <div className="shine-wrap">
                            <div className="shine"></div>
                        </div>
                        <div className="card-content-vertical">
                            <div className="contact-card-grid">
                                <div>
                                    <div className="app-list">
                                        <div className="app-wrap">
                                            <div className="app-icon w-embed">
                                                <svg viewBox="0 0 40 40" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="40" height="40" rx="0" fill="#55ACEE"></rect>
                                                    <mask id="mask0_920_2751" style={{maskType: "luminance"}}
                                                          maskUnits="userSpaceOnUse" x="8" y="10" width="24"
                                                          height="20">
                                                        <path d="M31.9309 10.2326H8V29.6807H31.9309V10.2326Z"
                                                              fill="white"></path>
                                                    </mask>
                                                    <g mask="url(#mask0_920_2751)">
                                                        <path
                                                            d="M31.9309 12.5347C31.0506 12.9253 30.1043 13.1891 29.1112 13.3078C30.1248 12.7002 30.9034 11.7381 31.27 10.5915C30.3211 11.1543 29.2704 11.5628 28.152 11.7829C27.2565 10.8287 25.9806 10.2326 24.5684 10.2326C21.857 10.2326 19.6586 12.4307 19.6586 15.1421C19.6586 15.5269 19.702 15.9017 19.7858 16.261C15.7053 16.0563 12.0876 14.1016 9.66603 11.1312C9.24342 11.8563 9.00123 12.6996 9.00123 13.5994C9.00123 15.3028 9.86801 16.8056 11.1854 17.686C10.3806 17.6605 9.62356 17.4396 8.96163 17.0719C8.96107 17.0924 8.96107 17.113 8.96107 17.1337C8.96107 19.5124 10.6535 21.4967 12.8995 21.948C12.4876 22.0602 12.0538 22.1202 11.606 22.1202C11.2897 22.1202 10.9822 22.0893 10.6823 22.032C11.3071 23.9826 13.1203 25.4021 15.2688 25.4416C13.5885 26.7585 11.4716 27.5434 9.17118 27.5434C8.77489 27.5434 8.38409 27.5201 8 27.4747C10.1728 28.8679 12.7535 29.6807 15.5262 29.6807C24.5569 29.6807 29.4955 22.1995 29.4955 15.7113C29.4955 15.4985 29.4906 15.2868 29.4813 15.0761C30.4404 14.384 31.2727 13.5194 31.9309 12.5347Z"
                                                            fill="white"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div className="app-outline"></div>
                                        </div>
                                        <div>Twitter</div>
                                    </div>
                                </div>
                                <div id="w-node-_11b37cf0-2d4f-ab47-a08c-2ec24bd56f10-a30fcb40">
                                    <div className="button-small">
                                        <div>Follow</div>
                                        <div className="text-muted">1.2K</div>
                                    </div>
                                </div>
                                <div id="w-node-_497da4c6-d155-ec97-cec0-775e3de3da53-a30fcb40">
                                    <div>@mufarogom</div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div className="block-divider"></div>
            <div className="section-block">
                <div className="content-title-wrap">
                    <div className="content-title-dot"></div>
                    <h2 className="content-title">Send a message</h2>
                </div>
                <div className="form-block w-form">
                    <form id="send-a-message" name="email-form" data-name="Email Form" method="get">
                        <div className="w-layout-grid _4x-column">
                            <input type="text"
                                   className="text-field w-node-dded5a54-873d-d79f-ebda-88c1618dbf98-a30fcb40 w-input"
                                   maxLength="256" name="name" data-name="Name" placeholder="Your Name"
                                   id="name"/>
                            <input type="email"
                                   className="text-field w-node-dded5a54-873d-d79f-ebda-88c1618dbf9b-a30fcb40 w-input"
                                   maxLength="256" name="email" data-name="Email" placeholder="Your Email"
                                   id="email" required=""/>
                            <textarea placeholder="Your Message..." maxLength="5000" id="field" name="field"
                                      data-name="Field"
                                      className="text-field is-area w-node-a612c34c-b2f2-57d5-3790-23f702446650-a30fcb40 w-input"></textarea>
                            <input type="submit" value="Submit" data-wait="Please wait..."
                                   id="w-node-dded5a54-873d-d79f-ebda-88c1618dbf9c-a30fcb40"
                                   className="button w-button"/>
                        </div>
                    </form>
                    <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                </div>
            </div>
            <div className="block-divider"></div>
            <div className="section-block">
                <div className="container-small">
                    <div id="w-node-a369da3c-b68f-1601-ab35-f5e617709191-a30fcb40" className="newsletter-wrap">
                        <div className="newsletter-image-wrap">
                            <div className="newsletter-image">
                                <div className="newsletter-image-icon-size">
                                    <div className="icon-svg w-embed">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                             fill="currentColor">
                                            <path fill-rule="evenodd"
                                                  d="M5.478 5.559A1.5 1.5 0 016.912 4.5H9A.75.75 0 009 3H6.912a3 3 0 00-2.868 2.118l-2.411 7.838a3 3 0 00-.133.882V18a3 3 0 003 3h15a3 3 0 003-3v-4.162c0-.299-.045-.596-.133-.882l-2.412-7.838A3 3 0 0017.088 3H15a.75.75 0 000 1.5h2.088a1.5 1.5 0 011.434 1.059l2.213 7.191H17.89a3 3 0 00-2.684 1.658l-.256.513a1.5 1.5 0 01-1.342.829h-3.218a1.5 1.5 0 01-1.342-.83l-.256-.512a3 3 0 00-2.684-1.658H3.265l2.213-7.191z"
                                                  clip-rule="evenodd"/>
                                            <path fill-rule="evenodd" fill="#912eff"
                                                  d="M12 2.25a.75.75 0 01.75.75v6.44l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3a.75.75 0 011.06-1.06l1.72 1.72V3a.75.75 0 01.75-.75z"
                                                  clip-rule="evenodd"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div className="newsletter-image-outline"></div>
                        </div>
                        <div className="newsletter-content">
                            <div className="newsletter-content-top">
                                <h2 className="card-heading">Get notified when we release new products.</h2>
                                <div>We never share your data, and we send approximately 1-2 emails per month.
                                </div>
                            </div>
                            <div className="form-block w-form">
                                <form id="email-form" name="email-form" data-name="Email Form" method="get">
                                    <div className="w-layout-grid newsletter-grid">
                                        <input type="email" className="text-field w-input" maxLength="256"
                                               name="Email" data-name="Email" placeholder="Your Email"
                                               id="Email-2" required=""/>
                                        <input type="submit" value="Subscribe now" data-wait="Please wait..."
                                               id="w-node-f73469b8-aabc-5f4f-558a-b381e07e4b3c-a30fcb40"
                                               className="button is-submit w-button"/>
                                    </div>
                                </form>
                                <div className="w-form-done">
                                    <div>Thank you! Your submission has been received!</div>
                                </div>
                                <div className="w-form-fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactPage